import {
	trigger,
	state,
	style,
	transition,
	animate
} from '@angular/animations';

const highlightColor = '#ff8000';

export const fieldTransitions = [
	trigger('appearAnimation', [
		state('highlight', style({
			backgroundColor: 'none',
		})),
		transition('* => highlight', [
			animate('1.5s ease-in', style({ backgroundColor: highlightColor, transform: 'scale(1.05)' })),
			animate('1.5s ease-out', style({ backgroundColor: 'none', transform: 'scale(1)' }))
		])
	])
];
